import React, {ReactElement} from "react";
import {SidebarContext, SidebarRenderer} from "../types";
import {CommentsSidebarView} from "./CommentsSidebarView";

export class CommentsSidebarRenderer implements SidebarRenderer {

  renderToolbar(): ReactElement {
    return null;
  }

  renderContent(context?: SidebarContext): ReactElement {
    return <CommentsSidebarView
      comments={context?.comments || []}
      onAdd={text => {
        context?.onAddComment?.({
          id: `comment_${Date.now()}`,
          x: 0,
          y: 0,
          text,
          timestamp: Date.now(),
        });
      }}
      onDelete={id => context?.onDeleteComment?.(id)}
      onSelect={id => context?.onSelectComment?.(id)}
    />;
  }
}
